import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import RepliesLoader from './_load/RepliesLoader'
import RepliesTable from './RepliesTable'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ReplyDetailsModal = props => (
  <ControlledModal width="62rem" {...props}>
    <FilterHandler>
      <RepliesLoader>
        <ModalHeader />
        <Separator weight={4} />
        <RepliesTable />
      </RepliesLoader>
    </FilterHandler>
  </ControlledModal>
)

export default ReplyDetailsModal
